import { render, staticRenderFns } from "./AgendaSlotComponent.vue?vue&type=template&id=2d0690c8&scoped=true"
import script from "./AgendaSlotComponent.vue?vue&type=script&lang=js"
export * from "./AgendaSlotComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaSlotComponent.vue?vue&type=style&index=0&id=2d0690c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0690c8",
  null
  
)

export default component.exports